"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _renderProps = require("../../../libs/renderProps");

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _SearchableFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/SearchableFilterSelector"));

var _productAreas = require("@insided/shared/utils/productAreas");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ProductAreasFilterSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductAreasFilterSelector, _Component);

  var _super = _createSuper(ProductAreasFilterSelector);

  function ProductAreasFilterSelector() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductAreasFilterSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "flattenPAList", (0, _productAreas.flattenPAList)((0, _productAreas.getNormalizedPAList)(_this.props.items)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedProductAreasIds: _this.props.selectedFilterItems ? (0, _productAreas.mapProductAreaIdsToString)(_this.props.selectedFilterItems) : []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelect", function (productId, checked) {
      var selectedProductAreasIds = _this.state.selectedProductAreasIds;
      var productArea = (0, _productAreas.findProductAreaById)((0, _productAreas.getNormalizedPAList)(_this.props.items), productId);
      if (!productArea) return;
      var childrenIds = productArea.isSection ? (0, _productAreas.getChildPAIds)(productArea.children) : [];
      var updatedSelectedIds = checked ? (0, _productAreas.addPAIdsToList)(selectedProductAreasIds, productArea, childrenIds) : (0, _productAreas.removePAIdsFromList)(selectedProductAreasIds, productArea, childrenIds);

      _this.setState({
        selectedProductAreasIds: updatedSelectedIds
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderContent", function (productAreas) {
      var selectedProductAreasIds = _this.state.selectedProductAreasIds;
      return (0, _preact.h)(_NestedDropdown.default, {
        items: productAreas,
        onMultiSelect: _this.onSelect,
        selectedItems: selectedProductAreasIds,
        depth: 1
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ProductAreasFilterSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          items = _this$props.items;
      var selectedProductAreasIds = this.state.selectedProductAreasIds;
      return (0, _preact.h)("div", null, (0, _preact.h)(_SearchableFilterSelector.default, {
        items: this.flattenPAList,
        placeholder: "Search for product area"
      }, function (_ref) {
        var value = _ref.value;
        var filteredPA = (0, _productAreas.getFilteredProductAreas)(value, (0, _productAreas.getNormalizedPAList)(items));
        return _this2.renderContent(filteredPA);
      }), (0, _renderProps.extractRenderPropsChildren)(children)({
        data: (0, _productAreas.getSelectedProductAreas)(selectedProductAreasIds, (0, _productAreas.getNormalizedPAList)(this.props.items)),
        isApplyButtonDisabled: selectedProductAreasIds.length === 0
      }));
    }
  }]);
  return ProductAreasFilterSelector;
}(_preact.Component);

(0, _defineProperty2.default)(ProductAreasFilterSelector, "create", function (config) {
  return _objectSpread({
    component: ProductAreasFilterSelector,
    type: 'filter',
    getPillDisplayValue: function getPillDisplayValue(data) {
      var firstItem = data[0].name;
      var otherItems = data.length > 1 ? "+".concat(data.length - 1) : '';
      return "".concat(firstItem, " ").concat(otherItems);
    }
  }, config);
});
var _default = ProductAreasFilterSelector;
exports.default = _default;